import React, { useState, useEffect } from 'react';
import EditarLaborUM from './EditarLaborUM';
import EditarLabores from './EditarLabores';
import { set, size } from 'lodash';

const AreasSection = (p) => {
    const data = p.data;
    const keys = p.keys;
    const type = p.type;
    const [edit, setedit] = useState();
    const [newReg, setnewReg] = useState(false);
    const closeEdit = () => {
        setedit(null);
        setnewReg(false);
    };
    const inputs = {
        'areas': [{ label: 'Nombre del área', type: 'text', name: 'nombre', size: 300, disable: false }, { label: 'Descripción', type: 'text', name: 'des', size: 400, disable: false }],
        'labores': [{ label: 'Nombre de la labor', type: 'text', name: 'labor', size: 600, disable: false }],
        'um': [{ label: 'Nombre de la unidad de medida', type: 'text', name: 'nombre', size: 600, disable: false }],
    }

    return (
        <div className='w-100 text-center p-0 mt-3 round-l overflow' style={{ height: "78vh" }}>
            <div className='row justify-content-evenly w-100 m-0 p-0'>
                <div className={type === 'labores' ? 'bw-1000' : 'bw-600'}>
                    <table className='table table-sm table-hover p-0 m-0'>
                        <thead>
                            <tr>
                                {keys.map((k, i) => <th key={i} scope='col' className='text-blue4 nowrap'>{k.name}</th>)}

                            </tr>
                        </thead>
                        <tbody>
                            {data.map((d, i) =>
                                <tr key={i + "erfd"} className='pointer nowrap' onClick={() => { setedit(d) }}>
                                    {keys.map((k, j) => <td key={j + "ddd" + i}>{d[k.key]}</td>)}
                                </tr>
                            )}

                        </tbody>
                    </table>

                </div>
                <div className='w-100'></div>
                <button className='btn btn-light shadow bw-400 mt-3 mb-5 round-xxl border border-warning border-2 text-bold' onClick={() => { setnewReg(true) }}>Nuevo registro</button>
            </div>
            {(edit || newReg) && type != 'labores' && <EditarLaborUM data={edit} close={closeEdit} update={p.update} inputs={inputs[type]} type={type} />}
            {(edit || newReg) && type === 'labores' && <EditarLabores data={edit} close={closeEdit} update={p.update} />}
        </div>
    )
}

export default AreasSection;